<div class="no-content d-flex flex-column align-items-center">
  <img src="../../../assets/images/no-content.svg" alt="No Result Icon" class="img-fluid" />
  <p>{{"TABLES.NO_CONTENT" | translate}}</p>
</div>